const resolveGroupKey = (item) => item?.sub_group_id ?? item?.id ?? null
const resolveOriginalIdForAnchor = (anchor) => anchor?.id ?? null

export const groupMediaBySubGroup = (media = []) => {
  const groupsByKey = new Map()
  const orderedKeys = []

  media.forEach((item, index) => {
    const key = resolveGroupKey(item)
    if (!key) return

    if (!groupsByKey.has(key)) {
      groupsByKey.set(key, {
        groupKey: key,
        firstIndex: index,
        items: [],
      })
      orderedKeys.push(key)
    }

    groupsByKey.get(key).items.push(item)
  })

  return orderedKeys.map((key) => groupsByKey.get(key))
}

export const getGroupAnchor = (group) => group?.items?.[0] ?? null

const buildGroupListItem = ({ subGroupId, images, anchor, originalId, firstIndex }) => ({
  key: `group-${subGroupId}`,
  subGroupId,
  headline: images.find((item) => item.headline != null)?.headline ?? null,
  images,
  anchor,
  originalId,
  itemsCount: images.length,
  firstIndex,
})

export const buildLiveGroupListItem = (media = [], groupPreview) => {
  if (!groupPreview?.subGroupId) {
    return groupPreview ?? null
  }

  const group = groupMediaBySubGroup(media).find((entry) => String(entry.groupKey) === String(groupPreview.subGroupId))
  const images = group?.items ?? []
  const anchor = getGroupAnchor(group)

  if (!images.length || !anchor) {
    return null
  }

  return {
    ...groupPreview,
    headline: images.find((item) => item.headline != null)?.headline ?? null,
    images,
    anchor,
    itemsCount: images.length,
  }
}

export const buildMediaListItems = (media = []) => {
  if (!media.length) {
    return []
  }

  return groupMediaBySubGroup(media)
    .map((group) => {
      const anchor = getGroupAnchor(group)
      if (!anchor) return null

      return buildGroupListItem({
        subGroupId: group.groupKey,
        images: group.items,
        anchor,
        originalId: resolveOriginalIdForAnchor(anchor),
        firstIndex: group.firstIndex,
      })
    })
    .filter(Boolean)
}

export const countDisplaySlots = (media = []) => buildMediaListItems(media).length
